import React, { useEffect, useState, } from 'react';
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import {
    buttonProcessGet, responseGet, globalSettings, setBadgeStatusGeneric, numberSet, styles, validateDecimals, dateTimeFormatGlobalSet, sendMessageCloseCurrentWindowAsync,
    separatorsNumbersSet, languageObjGet, isUndNullEmp, awaitDelay, isUndNull,
} from '../../helpers/settings';
import moment from 'moment-timezone';
import axios from 'axios';

import 'react-tempusdominus-bootstrap';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { collectionCashModelGet } from '../../models/collections/collectionCash';
import { coinModelGet } from '../../models/coins/coin';

const currentMethod = 'CollectionCashAddEditDetails';
const { icons, labels, messages, } = globalSettings;
const { html, tempusDominus, } = globalSettings?.react;
const { properties: dbProps, } = globalSettings?.collections;
const { backend, } = globalSettings?.app;
const neutralValue = 0.00;

export default function CollectionCashAddEditDetails({
    $ = {},
    auth = {},
    building = buildingModelGet({}),
    buildingBalanceCalculateSetAsync = async ({
        collectionCash = collectionCashModelGet({}),
        subMethod = '',
    }) => { },
    collectionCash = collectionCashModelGet({}),
    setCollectionCash = () => { },
    coins = [coinModelGet({})],
    dtCollectionCashesId = '',
    dtRowIndex = 0,
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result), }) {
    //#region variables
    let result;
    let dataObj = {};
    let dtRowObj = {};
    let headerObj = {};
    const collectionCashDateId = 'collectionCashDate';
    const [descriptionError, setDescriptionError] = useState('');
    const [dateError, setDateError] = useState('');
    const [coinError, setCoinError] = useState('');
    const [initialBalanceCashError, setInitialBalanceCashError] = useState('');
    const [currentBalanceCashError, setCurrentBalanceCashError] = useState('');
    const [initialBalanceError, setInitialBalanceError] = useState('');
    const [currentBalanceError, setCurrentBalanceError] = useState('');
    const [collectionCashBefore, setCollectionCashBefore] = useState(collectionCashModelGet({}));
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnCollectionCashModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnCollectionCashModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnCollectionCashModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            inactive: {
                id: 'chkCollectionCashModalEnable',
                className: 'icheck-primary d-inline',
            },
            inactiveReadOnly: {
                id: 'chkCollectionCashModalReadOnly',
                className: 'icheck-primary d-inline',
            },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtCollectionCashesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtCollectionCashesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtCollectionCashesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtCollectionCashesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtCollectionCashesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtCollectionCashesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtCollectionCashesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtCollectionCashesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoCollectionCashModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoCollectionCashModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoCollectionCashModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            description: {
                id: 'inputCollectionCashModalDescription',
                className: 'form-control',
            },
            date: {
                id: 'inputCollectionCashModalDate',
                className: 'form-control datetimepicker-input',
            },
            cashInitial: {
                id: 'inputCollectionCashModalCashInitial',
                className: 'form-control text-right',
            },
            cashCurrent: {
                id: 'inputCollectionCashModalCashCurrent',
                className: 'form-control text-right',
            },
            balanceInitial: {
                id: 'inputCollectionCashModalBalanceInitial',
                className: 'form-control text-right',
            },
            balanceCurrent: {
                id: 'inputCollectionCashModalBalanceCurrent',
                className: 'form-control text-right',
            },
        },
        selects: {
            coins: {
                id: 'selCollectionCashModalCoins',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spCollectionCashModalSave',
                className: '',
            },
            back: {
                id: 'spCollectionCashModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods (collectionCash)
    const collectionChashAddAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'collectionChashAddAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let collectionCashLocal = collectionCashModelGet({});
            //#endregion variables

            //#region initialize
            response = await errorDefaultSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region dataCollectionCashSetAsync
            response = await dataCollectionCashSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dataCollectionCashSetAsync

            //#region formDataValidateAsync
            response = await formDataValidateAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion formDataValidateAsync

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create collection cash
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                collectionCash: collectionCash,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCollectionCashes}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            collectionCashLocal = response?.result || {};
            setCollectionCash(collectionCashLocal);
            //#endregion create collection cash

            //#region add record dtCollectionCashes
            //#region variables
            dtRowObj = {
                description: collectionCashLocal?.description,
                date: dateTimeFormatGlobalSet({
                    date: collectionCashLocal?.date,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                status: setBadgeStatusGeneric({
                    type: collectionCashLocal?.inactive ? 1 : 0,
                    value: collectionCashLocal.inactive ? labels?.inactive?.[languageObj?.id] : labels?.active?.[languageObj?.id],
                    subMethod: currentMethod,
                }),
                initialBalance: separatorsNumbersSet({
                    number: numberSet({
                        number: collectionCashLocal?.initialBalance,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                currentBalance: separatorsNumbersSet({
                    number: numberSet({
                        number: collectionCashLocal?.currentBalance,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                processButtons: [
                    {
                        isVisible: true,
                        showDivider: false,
                        label: labels?.movements?.[languageObj?.id],
                        isEnabled: true,
                        methodName: backend?.methods?.movements,
                        icon: icons?.chartLine,
                    },
                    {
                        isVisible: true,
                        showDivider: true,
                        label: labels?.delete?.[languageObj?.id],
                        isEnabled: true,
                        methodName: backend?.methods?.delete,
                        icon: icons?.trash,
                    },
                ],
            };
            //#endregion variables

            //#region methods
            dataObj = [
                //#region old code
                // collectionCashLocal.description,
                // dateTimeFormatGlobalSet(collectionCashLocal.date, tempusDominus?.format?.date?.dmy, 0, true).result,
                // setBadgeStatusGeneric((collectionCashLocal.inactive ? 1 : 0), (collectionCashLocal.inactive ? labels?.inactive?.[languageObj?.id] : labels?.active?.[languageObj?.id])),
                // separatorsNumbersSet(numberSet((collectionCashLocal.initialBalance), 'd').result, true).result,
                // separatorsNumbersSet(collectionCashLocal.currentBalance, true).result,
                //#endregion old code
                dtRowObj?.description,
                dtRowObj?.date,
                dtRowObj?.status,
                dtRowObj?.initialBalance,
                dtRowObj?.currentBalance,
                buttonProcessGet({
                    id: collectionCashLocal?.id,
                    description: dtRowObj?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: false,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: dtRowObj?.processButtons,
                    subMethod: currentMethod,
                })?.result,
            ];

            $(`#${dtCollectionCashesId}`)?.DataTable()?.row?.add(dataObj)?.draw(true);
            //#endregion methods

            //#region calculation building balance
            response = await buildingBalanceCalculateSetAsync({
                collectionCash: collectionCashLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion calculation building balance
            //#endregion add record dtCollectionCashes

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const collectionChashEditPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'collectionChashEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRow = [];
            let collectionCashLocal = collectionCashModelGet({});
            //#endregion variables

            //#region initialize
            response = await errorDefaultSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region dataCollectionCashSetAsync
            response = await dataCollectionCashSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dataCollectionCashSetAsync

            //#region formDataValidateAsync
            response = await formDataValidateAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion formDataValidateAsync

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region update data (collection cash)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                collectionCash: collectionCash,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCollectionCashes}/${collectionCash?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            collectionCashLocal = response?.result || {};
            setCollectionCash(collectionCashLocal);
            //#endregion update data (collection cash)

            //#region add record dtCollectionCashes
            //#region variables
            dtRowObj = {
                description: collectionCashLocal?.description,
                date: dateTimeFormatGlobalSet({
                    date: collectionCashLocal?.date,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: true,
                    secondsShow: true,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                inactive: setBadgeStatusGeneric({
                    type: collectionCashLocal?.inactive ? 1 : 0,
                    value: collectionCashLocal?.inactive ? labels?.inactive?.[languageObj?.id] : labels?.active?.[languageObj?.id],
                    subMethod: currentMethod,
                }),
                initialBalance: separatorsNumbersSet({
                    number: collectionCashLocal?.initialBalance,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                currentBalance: separatorsNumbersSet({
                    number: collectionCashLocal?.currentBalance,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                processButtons: [
                    {
                        isVisible: true,
                        showDivider: false,
                        label: labels?.movements?.[languageObj?.id],
                        isEnabled: true,
                        methodName: backend?.methods?.movements,
                        icon: icons?.receipt,
                    },
                    {
                        isVisible: true,
                        showDivider: true,
                        label: labels?.delete?.[languageObj?.id],
                        isEnabled: true,
                        methodName: backend?.methods?.delete,
                        icon: icons?.trash,
                    },
                ],
            };
            //#endregion variables

            //#region methods 
            dtRow = [
                //#region old code
                // collectionCashLocal.description,
                // dateTimeFormatGlobalSet(collectionCashLocal.date, tempusDominus?.format?.date?.dmy, 0, true).result,
                // setBadgeStatusGeneric((collectionCashLocal.inactive ? 1 : 0), (collectionCashLocal.inactive ? labels?.inactive?.[languageObj?.id] : labels?.active?.[languageObj?.id])),
                // separatorsNumbersSet(collectionCashLocal.initialBalance, true).result,
                // separatorsNumbersSet(collectionCashLocal.currentBalance, true).result,
                //#endregion old code
                dtRowObj?.description,
                dtRowObj?.date,
                dtRowObj?.inactive,
                dtRowObj?.initialBalance,
                dtRowObj?.currentBalance,
                buttonProcessGet({
                    id: collectionCashLocal?.id,
                    description: collectionCashLocal?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: false,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: dtRowObj?.processButtons,
                    subMethod: currentMethod,
                })?.result,
            ];

            $(`#${dtCollectionCashesId}`)?.DataTable()?.row(dtRowIndex).data(dtRow)?.draw(true);
            //#endregion methods

            //#region calculation building balance
            response = await buildingBalanceCalculateSetAsync({
                collectionCash: collectionCashLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion calculation building balance
            //#endregion add record dtCollectionCashes

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (collectionCash)

    //#region methods (others)
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region dateTime control set
            response = await dateInControlSetAsync({
                date: new Date(),
                collectionCashDate: collectionCash?.date,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dateTime control set

            setCollectionCashBefore(collectionCash);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dateInControlSetAsync = async ({
        date = new Date(),
        collectionCashDate = undefined,
        subMethod = '',
    }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.date = '';
            //const dateTimeObj?.format = tempusDominus?.format?.date?.DDMMYYYY;
            //const dateTimeObj?.formatTwo = tempusDominus?.format?.date?.dmy;
            //#endregion old code
            const dateTimeObj = {
                date: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: collectionCashDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: collectionCashDate,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: collectionCashDate,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: tempusDominus?.icons,
                buttons: tempusDominus?.buttons,
                tooltips: tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            $(`#${collectionCashDateId}`)?.datetimepicker({
                date: moment(dateTimeObj?.date, dateTimeObj?.formatTwo),
                default: false,
                timepicker: false,
                format: dateTimeObj?.formatTwo,
                ignoreReadonly: true,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errorDefaultSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'errorDefaultSetAsync';
        let response = responseGet();
        try {
            setDateError('');
            setCoinError('');
            setDescriptionError('');
            setCurrentBalanceError('');
            setInitialBalanceError('');
            setInitialBalanceCashError('');
            setCurrentBalanceCashError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataCollectionCashSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataCollectionCashSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dateTimeLocal = {};
            let initialBalanceLocal = collectionCash?.initialBalance;//neutralValue;
            let currentBalanceLocal = collectionCash?.currentBalance;//neutralValue;
            let initialBalanceCashLocal = collectionCash?.initialBalanceCash;//neutralValue;
            let currentBalanceCashLocal = collectionCash?.currentBalanceCash;//neutralValue;
            //#endregion variables

            //#region initialize
            dateTimeLocal = $(`#${collectionCashDateId}`)?.datetimepicker('date')?._d;
            collectionCash.date = !isUndNullEmp({ data: dateTimeLocal, subMethod: currentMethod, })?.result ? dateTimeLocal : collectionCash?.date;
            collectionCash.initialBalanceCash = !isUndNullEmp({ data: collectionCash?.initialBalanceCash, subMethod: currentMethod, })?.result ?
                numberSet({
                    number: collectionCash?.initialBalanceCash,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result : neutralValue;
            collectionCash.currentBalanceCash = !isUndNullEmp({ data: collectionCash?.currentBalanceCash, subMethod: currentMethod, })?.result ?
                numberSet({
                    number: collectionCash?.currentBalanceCash,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result : neutralValue;
            collectionCash.initialBalance = !isUndNullEmp({ data: collectionCash?.initialBalance, subMethod: currentMethod, })?.result ?
                numberSet({
                    number: collectionCash?.initialBalance,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result : neutralValue;
            collectionCash.currentBalance = !isUndNullEmp({ data: collectionCash?.currentBalance, subMethod: currentMethod, })?.result ?
                numberSet({
                    number: collectionCash?.currentBalance,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result : neutralValue;
            //#endregion initialize

            //#region process
            if (processType === 0) {
                initialBalanceCashLocal = collectionCash?.initialBalanceCash;
                initialBalanceLocal = collectionCash?.initialBalance;

                if ((initialBalanceCashLocal > 0 && initialBalanceLocal === 0) || (initialBalanceCashLocal === initialBalanceLocal)) {
                    collectionCash.currentBalanceCash = initialBalanceCashLocal;
                    collectionCash.initialBalance = initialBalanceCashLocal;
                    collectionCash.currentBalance = initialBalanceCashLocal;
                } else if ((initialBalanceCashLocal > initialBalanceLocal) ||
                    (initialBalanceCashLocal === 0 && initialBalanceLocal > 0) ||
                    (initialBalanceCashLocal < initialBalanceLocal)) {
                    collectionCash.currentBalanceCash = initialBalanceCashLocal;
                    collectionCash.initialBalance = initialBalanceLocal;
                    collectionCash.currentBalance = initialBalanceLocal;
                }
            } else {
                if (collectionCashBefore?.initialBalanceCash === 0 && collectionCashBefore?.currentBalanceCash === 0 &&
                    collectionCashBefore?.initialBalance === 0 && collectionCashBefore?.currentBalance === 0) {
                    initialBalanceCashLocal = collectionCash?.initialBalanceCash;
                    initialBalanceLocal = collectionCash?.initialBalance;

                    if ((initialBalanceCashLocal > 0 && initialBalanceLocal === 0) || (initialBalanceCashLocal === initialBalanceLocal)) {
                        collectionCash.currentBalanceCash = initialBalanceCashLocal;
                        collectionCash.initialBalance = initialBalanceCashLocal;
                        collectionCash.currentBalance = initialBalanceCashLocal;
                    } else if ((initialBalanceCashLocal > initialBalanceLocal) ||
                        (initialBalanceCashLocal === 0 && initialBalanceLocal > 0) ||
                        (initialBalanceCashLocal < initialBalanceLocal)) {
                        collectionCash.currentBalanceCash = initialBalanceCashLocal;
                        collectionCash.initialBalance = initialBalanceLocal;
                        collectionCash.currentBalance = initialBalanceLocal;
                    }
                } else {
                    if (collectionCash?.initialBalanceCash !== collectionCashBefore?.initialBalanceCash) {
                        initialBalanceCashLocal = numberSet({
                            number: ((collectionCash?.initialBalanceCash - collectionCashBefore?.initialBalanceCash) + collectionCashBefore?.initialBalanceCash),
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        currentBalanceCashLocal = numberSet({
                            number: ((collectionCash?.initialBalanceCash - collectionCashBefore?.initialBalanceCash) + collectionCashBefore?.currentBalanceCash),
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                    }
                    collectionCash.initialBalanceCash = initialBalanceCashLocal;
                    collectionCash.currentBalanceCash = currentBalanceCashLocal;

                    if (collectionCash?.initialBalance !== collectionCashBefore?.initialBalance ||
                        collectionCash?.initialBalanceCash !== collectionCashBefore?.initialBalanceCash
                    ) {
                        initialBalanceLocal = numberSet({
                            number: ((collectionCash?.initialBalanceCash - collectionCashBefore?.initialBalanceCash) + (collectionCash?.initialBalance - collectionCashBefore?.initialBalance) + (collectionCashBefore?.initialBalance)),
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        //#region old code
                        // currentBalanceLocal = numberSet({
                        //     number: ((collectionCash?.initialBalanceCash - collectionCashBefore?.initialBalanceCash) + (collectionCash?.initialBalance - collectionCashBefore?.currentBalance) + (collectionCashBefore?.currentBalance)),
                        //     type: 'd',
                        //     languageId: languageObj?.id,
                        //     subMethod: currentMethod,
                        // })?.result;
                        //#endregion old code
                        currentBalanceLocal = numberSet({
                            number: ((collectionCash?.initialBalanceCash - collectionCashBefore?.initialBalanceCash) + (collectionCashBefore?.currentBalance)),
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;

                    }
                    collectionCash.initialBalance = initialBalanceLocal;
                    collectionCash.currentBalance = currentBalanceLocal;
                }
            }
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            const collectionCashDateInput = $(`#${controls?.inputs?.date?.id}`)?.val();
            //#endregion variables

            //#region process
            if (isUndNullEmp({ data: collectionCash?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: collectionCashDateInput, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: collectionCash?.date, subMethod: currentMethod, })?.result) {
                setDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: collectionCash?.coinId, subMethod: currentMethod, })?.result) {
                setCoinError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNull({ data: collectionCash?.initialBalanceCash, subMethod: currentMethod, })?.result) {
                setInitialBalanceCashError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.description?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.checkBox?.inactive?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.date?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.selects?.coins?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.cashInitial?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.balanceInitial?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
        //console?.log(0);
    }, [showModal]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt='collectionCash'
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.collectionCashLogo}></img> - {labels?.cashRegister?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : (processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase())})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ?
                collectionChashAddAsync({ e: e, subMethod: 'btn - collectionCashAdd', }) :
                processType === 1 ?
                    collectionChashEditPostAsync({ e: e, subMethod: 'form - collectionCashEdit' }) :
                    e?.preventDefault()}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => processType === 0 ? collectionChashAddAsync(e) : (processType === 1 ? collectionChashEditPostAsync(e) : e?.preventDefault())}> */}
                    {/* <div className='card card-primary card-outline shadow-lg'> */}
                    {/* <div className='card-header'>
                        <h6 className='card-title'>
                            <img alt={labels?.cashRegister?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.collectionCashLogo}></img> - {labels?.cashRegister?.[languageObj?.id]}
                        </h6>
                    </div> */}
                    {/*card header*/}

                    {/* <div className='card-body'> */}
                    {processType !== 2 ?
                        <div>
                            <div className='row '>
                                <div className='col-md-8'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.description?.id}
                                                className={controls?.inputs?.description?.className}
                                                //autoFocus
                                                onChange={(e) => setCollectionCash({
                                                    ...collectionCash,
                                                    [dbProps?.description]: e?.target?.value,
                                                })}
                                                onFocus={() => setDescriptionError('')}
                                                placeholder={labels?.description?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.description?.[languageObj?.id]}
                                                value={collectionCash?.description || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='form-group'>
                                        <div className='input-group'>
                                            <div className={controls?.checkBox?.inactive?.className}>
                                                <input id={controls?.checkBox?.inactive?.id}
                                                    checked={collectionCash?.inactive || false}
                                                    onChange={(e) => setCollectionCash({
                                                        ...collectionCash,
                                                        [dbProps?.inactive]: e?.target?.checked,
                                                    })}
                                                    tooltip='tooltip'
                                                    title={labels?.condition?.[languageObj?.id]}
                                                    type='checkbox' />
                                                <label className='text-muted'
                                                    htmlFor={controls?.checkBox?.inactive?.id}
                                                    tooltip='tooltip'
                                                    title={labels?.condition?.[languageObj?.id]}> {labels?.inactive?.[languageObj?.id]}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <div className='input-group date'
                                                id={collectionCashDateId}
                                                data-target-input='nearest'>
                                                <input id={controls?.inputs?.date?.id}
                                                    className={controls?.inputs?.date?.className}
                                                    data-target={`#${collectionCashDateId}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setDateError('')}
                                                    placeholder={labels?.date?.[languageObj?.id]}
                                                    //tabIndex={-1}
                                                    tooltip='tooltip'
                                                    title={labels?.date?.[languageObj?.id]}
                                                    readOnly={true}
                                                    type='text' />

                                                <div className='input-group-append'
                                                    data-target={`#${collectionCashDateId}`}
                                                    data-toggle='datetimepicker'>
                                                    <div className='input-group-text'>
                                                        <i className={icons?.calendarAlt}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.coins?.id}
                                                className={controls?.selects?.coins?.className}
                                                defaultValue={collectionCash?.coinId || ''}
                                                onChange={(e) => setCollectionCash({
                                                    ...collectionCash,
                                                    [dbProps?.coinId]: e?.target?.value,
                                                })}
                                                onFocus={() => setCoinError('')}
                                                placeholder={labels?.coin?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.coin?.[languageObj?.id]}>
                                                <option key='nothing' value=''>{messages?.selectCoin?.[languageObj?.id]}</option>
                                                {coins?.map(coin => (<option key={coin?.id} value={coin?.id}>{coin?.description}</option>))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-coins' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(coinError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4 text-muted'>
                                    {labels?.cash?.[languageObj?.id]}
                                </div>
                                <div className='col-md-8'>
                                    <hr />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.cashInitial?.id}
                                                className={controls?.inputs?.cashInitial?.className}
                                                onChange={(e) => setCollectionCash({
                                                    ...collectionCash,
                                                    [dbProps?.initialBalanceCash]: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - initialBalanceCash', })
                                                })}
                                                onFocus={() => setInitialBalanceCashError('')}
                                                placeholder={labels?.initialBalance?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.initialBalance?.[languageObj?.id]}
                                                value={collectionCash?.initialBalanceCash || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(initialBalanceCashError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.cashCurrent?.id}
                                                className={controls?.inputs?.cashCurrent?.className}
                                                onChange={(e) => setCollectionCash({
                                                    ...collectionCash,
                                                    [dbProps?.currentBalanceCash]: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'inpyt - currentBalanceCash', })
                                                })}
                                                onFocus={() => setCurrentBalanceCashError('')}
                                                placeholder={labels?.currentBalance?.[languageObj?.id]}
                                                readOnly={true}
                                                tooltip='tooltip'
                                                title={labels?.currentBalance?.[languageObj?.id]}
                                                value={collectionCash?.currentBalanceCash || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(currentBalanceCashError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4 text-muted'>
                                    {labels?.balance?.[languageObj?.id]}
                                </div>
                                <div className='col-md-8'>
                                    <hr />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.balanceInitial?.id}
                                                className={controls?.inputs?.balanceInitial?.className}
                                                onChange={(e) => setCollectionCash({
                                                    ...collectionCash,
                                                    [dbProps?.initialBalance]: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - initialBalance', })
                                                })}
                                                onFocus={() => setInitialBalanceError('')}
                                                placeholder={labels?.initialBalance?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.initialBalance?.[languageObj?.id]}
                                                value={collectionCash?.initialBalance || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(initialBalanceError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.balanceCurrent?.id}
                                                className={controls?.inputs?.balanceCurrent?.className}
                                                onChange={(e) => setCollectionCash({
                                                    ...collectionCash,
                                                    [dbProps?.currentBalance]: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - currentBalance', })
                                                })}
                                                onFocus={() => setCurrentBalanceError('')}
                                                placeholder={labels?.currentBalance?.[languageObj?.id]}
                                                readOnly
                                                tooltip='tooltip'
                                                title={labels?.currentBalance?.[languageObj?.id]}
                                                value={collectionCash?.currentBalance || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(currentBalanceError)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.description?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{collectionCash?.description || ''} </b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.inactive?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className={controls?.checkBox?.inactiveReadOnly?.className}>
                                        <input checked={collectionCash?.inactive || false}
                                            id={controls?.checkBox?.inactiveReadOnly?.id}
                                            readOnly={true}
                                            type='checkbox' />
                                        <label htmlFor={controls?.checkBox?.inactiveReadOnly?.id}></label>
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.coin?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{coins?.find(({ id }) => id === collectionCash?.coinId)?.description || ''} </b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.date?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        dateTimeFormatGlobalSet({
                                            date: collectionCash?.date,
                                            type: languageObj?.format?.date?.f1,
                                            format: 0,
                                            addTime: false,
                                            secondsShow: false,
                                            languageId: languageObj?.id,
                                            subMethod: 'lbl - date',
                                        })?.result
                                    } </b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    <b>{labels?.cash?.[languageObj?.id]}</b>
                                </div>
                                <div className='col-md-8'>
                                    <hr />
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.initialBalance?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        separatorsNumbersSet({
                                            number: collectionCash?.initialBalanceCash || neutralValue,
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: 'lbl - initialBalance',
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.currentBalance?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        separatorsNumbersSet({
                                            number: collectionCash?.currentBalanceCash || neutralValue,
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: 'lbl - currentBalanceCash',
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    <b>{labels?.bankAccounts?.[languageObj?.id]}</b>
                                </div>
                                <div className='col-md-8'>
                                    <hr />
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.initialBalance?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        separatorsNumbersSet({
                                            number: collectionCash?.initialBalance || neutralValue,
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: 'lbl - initialBalance',
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.currentBalance?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        separatorsNumbersSet({
                                            number: collectionCash?.currentBalance || neutralValue,
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: 'lbl - currentBalance',
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                        </div>
                    }
                    {/* </div> */}
                    {/* </div> */}

                    {/* <div className='form-group text-right'>
                        <button className='btn btn-outline-warning'
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'><i className={icons?.save}></i>
                        </button>
                        <button className='btn btn-outline-success mx-1'
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync(true)}>
                            <i className={icons?.arrowCircleLeft}></i>
                        </button>
                    </div> */}
                    {/* </form> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}